export const BaseUrl = "https://back-staging.orphanboards.com/api/v1/";

export const ROLES = {
  USER: "user",
  ADMIN: "admin",
  SUPER_ADMIN: "superAdmin",
  ORGANIZATION: "organization",
};
